import React, { useEffect } from "react";
import "../../styles/global.scss";
import { Helmet } from "react-helmet";
import gilroyLight from "../../../static/fonts/Gilroy-Light.otf";
import gilroySemiBold from "../../../static/fonts/Gilroy-SemiBold.otf";
import gilroyMedium from "../../../static/fonts/Gilroy-Medium.otf";

const customFonts = `
@font-face {
  font-family: "Gilroy";
  font-weight: 400;
  font-display: block;
  src: url("${gilroyMedium}") format("opentype");
}

@font-face {
  font-family: "Gilroy";
  font-weight: 200;
  font-display: block;
  src: url("${gilroyLight}") format("opentype");
}

@font-face {
  font-family: "Gilroy";
  font-weight: 600;
  font-display: block;
  src: url("${gilroySemiBold}") format("opentype");
}

`;

function Layout({ children, className }) {
  useEffect(() => {
    //intent.ly tracking code
    (function (s, m, a, r, t) {
      if (s.hasOwnProperty("$smcInstall")) return !1;
      s.$smcInstall = 1;
      s[r] = s[r] || [];
      var f = m.getElementsByTagName(a)[0],
        j = m.createElement(a),
        dl = r !== "dataLayer" ? "&r=" + r : "";
      j.async = true;
      j.src = "//smct.co/tm/?t=" + t + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, "script", "dataLayer", "feelcove.com");
  }, []);

  return (
    <>
      <Helmet>
        <link rel="preload" href={gilroyLight} as="font" type="font/otf" />
        <link rel="preload" href={gilroySemiBold} as="font" type="font/otf" />
        <link rel="preconnect" href="https://i.vimeocdn.com" />

        <style>{customFonts}</style>
      </Helmet>
      <div className={className}>{children}</div>
      <script
        async
        src="https://live.rezync.com/sync?c=16b6410431b6374e780104abb0443ca8&p=1468bf30b1aa7972123810aead8002d8&k=feelcove-landing-zync-pixel"
        type="text/javascript"
      ></script>
      <script
        type="text/javascript"
        src="//nexus.ensighten.com/choozle/16538/Bootstrap.js"
      ></script>
    </>
  );
}

export default Layout;
